<template>
  <!-- htc_hoverable -->
  <!-- htc_transition -->
  <!-- { htc_outlined: isOutlined && !displayEmpty }, -->
  <div
    ref="cell"
    :data-tst="`handtable_cell_${combo.id}`"
    :class="[
      'htc',
      { htc_dimmed: isDimmed && !displayEmpty },
      { htc_locked: isLocked && !displayEmpty },
      { htc_empty: displayEmpty },
      { htc_maximizible: maximizible },
      { htc_maximized: maximized },
    ]"
    :style="`--legend-items:${textRowsLength};`"
    @click="handleClick"
    @mouseenter="handleMouseenter"
    @mousedown="handleMousedown"
  >
    <!-- <div
      style="
        position: absolute;
        right: 2rem;
        top: 0;
        color: red;
        text-shadow: 0px 0px 2px black;
        font-size: 0.875rem;
        z-index: 99;
      "
    >
      {{ combo.id }} -- {{ combo.api_index }} -- {{ range }}
    </div> -->
    <!-- <i
      v-if="isLocked && !displayEmpty"
      class="htc_icon-lock mdi mdi-lock"
    ></i> -->
    <div
      v-if="hasTitle"
      class="htc_title"
    >
      <slot
        name="title"
        :item="combo"
      >
        <CardSymbols
          class="htc_title_symbols"
          :colorDefault="false"
          :cardsIds="combo.id"
          style="--size: var(--htc-title-size)"
        />
      </slot>
      <div
        v-if="blockers.hasSome && !displayEmpty"
        class="htc_title_blocker csst"
        data-tst="htc_title_blocker_active"
        @click.stop
        @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
      >
        <i
          v-if="blockers.blocker_rate"
          class="gw-icon-blocker-big htc_title_blocker_icon"
          :style="`color: ${getBlockerClr(blockers.blocker_rate)};`"
        ></i>
        <span
          v-if="blockers.blocker_rate"
          class="htc_title_blocker_value"
        >
          {{ blockers.blocker_rate }}
        </span>
        <i
          v-if="blockers.unblocker_rate"
          class="gw-icon-unblocker-big htc_title_blocker_icon"
          :style="`color: ${getBlockerClr(blockers.unblocker_rate)};`"
        ></i>
        <span
          v-if="blockers.unblocker_rate"
          class="htc_title_blocker_value"
        >
          {{ blockers.unblocker_rate }}
        </span>
        <div
          class="csst_content csst_content_hoverable flex-1 clr-white weight_600"
          style="position: fixed; line-height: 1.4; white-space: nowrap; padding: 0.75rem 0.75rem"
        >
          <div
            v-html="
              blockers.hasAll
                ? `${$t('tooltips.blocker_rate', {
                    num: blockers.blocker_rate,
                    icon: `<span class='gw-icon-blocker-big htc-tlltp-blocker-icon'></span>`,
                  })}
                ${$t('tooltips.unblocker_rate', {
                  num: blockers.unblocker_rate,
                  icon: `<span class='gw-icon-unblocker-big htc-tlltp-blocker-icon'></span>`,
                })}`
                : blockers.blocker_rate
                  ? $t('tooltips.blocker_rate', {
                      num: blockers.blocker_rate,
                      icon: `<span class='gw-icon-blocker-big htc-tlltp-blocker-icon'></span>`,
                    })
                  : $t('tooltips.unblocker_rate', {
                      num: blockers.unblocker_rate,
                      icon: `<span class='gw-icon-unblocker-big htc-tlltp-blocker-icon'></span>`,
                    })
            "
          ></div>
          <div
            class="mt-1 text-small clr-primary cursor-pointer"
            @click.stop="handleBlockerClick()"
          >
            <i class="mdi mdi-information mr-1"></i
            ><span class="text-underline clr-primary"
              >{{ $t('messages.more_about_blockers') }}
            </span>
          </div>
        </div>
      </div>
      <div
        v-else-if="!hasPremiumGameformat && hasBlockers"
        class="htc_title_blocker csst"
        :data-tst="`handtable_cell_${combo.id}_blocker`"
        @click.stop
        @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'bottom' })"
      >
        <i
          class="mdi mdi-shield"
          :style="`color: var(--clr-grey-2)`"
        ></i>
        <div
          class="csst_content csst_content_hoverable flex-1 clr-white"
          style="
            position: fixed;
            min-width: 160px;
            top: 100%;
            left: -4rem;
            --padding: 0.5rem 0.75rem;
          "
        >
          <div class="text-small clr-primary">
            <router-link
              class="gw_btn gw_btn_primary text-small weight_500 clr-white cursor-pointer"
              :to="{
                name: 'Subscription',
                query: { gm_type: gameformat ? gameformat.gm_type : '' },
              }"
              :data-tst="`handtable_cell_${combo.id}_upgrade_btn`"
              @click.stop
            >
              <i class="mdi mdi-crown mr-1"></i>
              {{
                gameformat
                  ? gameformat.gm_type === 'elite'
                    ? $t('btn.go_elite')
                    : $t('btn.go_premium')
                  : $t('btn.go_elite')
              }}
            </router-link>
            <div
              class="mt-2 cursor-pointer"
              @click.stop="handleBlockerClick()"
            >
              <i class="mdi mdi-information mr-1"></i
              ><span class="text-underline clr-primary"
                >{{ $t('messages.more_about_blockers') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <i
        v-if="isLocked && !displayEmpty"
        class="htc_title_lock mdi mdi-lock"
      ></i>
    </div>

    <div
      v-if="!displayEmpty && viewProps.study_solution_tab !== 'range'"
      v-show="valueKeys.some(i => i === showProp)"
      class="htc_value"
    >
      <slot
        name="value"
        :item="combo"
      ></slot>

      <span
        v-show="!noValue"
        v-html="
          showProp === 'ev'
            ? getEvHtml({
                ...bettingInfo,
                ignoreIcmEvIntercept: true,
                ev: comboPlayer.ev,
                player: player,
              })
            : `${numFixedUnit(
                comboPlayer[showProp === 'strategy_eq' ? 'eq' : showProp] *
                  (['strategy_eq', 'eq', 'eqr'].some(i => i === showProp) ? 100 : 1),
                showProp,
              )}${
                ['strategy_eq', 'eq', 'eqr'].some(i => i === showProp)
                  ? `<span class='ev-as-pot_percent'>%</span>`
                  : ''
              }`
        "
      ></span>
    </div>
    <div
      v-if="!displayEmpty"
      class="htc_content"
      :style="contentStyle"
    >
      <div
        v-show="
          ['strategy', 'strategy_ev', 'strategy_eq', 'overview_all'].some(i => i === showProp)
        "
        class="htc_graph"
      >
        <div
          v-for="(action, idx) in comboSolution"
          :key="`${action.code}_${idx}`"
          class="htc_graph_item"
          :class="action.css_class"
          :style="`width: ${action.strategy * 100}%;
                  ${useHex ? `background:${action.hex}` : ''}`"
        />
      </div>
    </div>

    <div
      v-if="
        hasLegend &&
        !displayEmpty &&
        range &&
        ((viewProps.study_solution_tab === 'range' && showProp !== 'strategy') ||
          showProp === 'overview_all')
      "
      class="htc_graph_legend"
    >
      <slot
        name="legend_before"
        :item="combo"
      ></slot>
      <div
        v-if="showProp === 'overview_all' && groupedBet"
        class="htc_graph_legend_item"
      >
        <span>{{ $t(`browse.${groupedBet.group_display_name}`) }}</span>
        <span
          >{{ numFixedUnit(groupedBet.strategy * 100, 'strategy')
          }}<span class="htc_graph_legend_item_unit">%</span></span
        >
      </div>
      <div
        v-if="comboPlayer.range"
        class="htc_graph_legend_item"
      >
        <span>{{ $t('table_head.range') }}</span>
        <span>{{ numFixedUnit(comboPlayer.range, 'range') }}</span>
      </div>
      <div class="htc_graph_legend_item">
        <span v-html="getEvUnitHtml({ ...bettingInfo, player: player })"></span>
        <span
          v-html="
            getEvHtml({
              ...bettingInfo,
              ignoreIcmEvIntercept: true,
              ev: comboPlayer.ev,
              percent_css_class: 'htc_graph_legend_item_unit',
              player: player,
            })
          "
        />
      </div>
      <div
        v-if="showFlopContent"
        class="htc_graph_legend_item"
      >
        <span>EQ</span>
        <span
          >{{ numFixedUnit(comboPlayer.eq * 100, 'eq')
          }}<span class="htc_graph_legend_item_unit">%</span>
        </span>
      </div>
      <div
        v-if="showFlopContent"
        class="htc_graph_legend_item"
      >
        <span>EQR</span>
        <span
          >{{ numFixedUnit(comboPlayer.eqr * 100, 'eqr')
          }}<span class="htc_graph_legend_item_unit">%</span>
        </span>
      </div>
    </div>

    <div
      v-if="
        hasLegend &&
        !displayEmpty &&
        range &&
        (showProp === 'strategy' ||
          showProp === 'strategy_ev' ||
          showProp === 'ev_compare' ||
          (showProp === 'ev' && viewProps.study_solution_tab !== 'range'))
      "
      class="htc_graph_legend"
    >
      <slot
        name="legend_before"
        :item="combo"
      ></slot>
      <div
        v-for="(action, idx) in comboSolutionLegend"
        :key="`${action.code}_${idx}`"
        class="htc_graph_legend_item"
        :data-tst="`htc_action_${idx}`"
      >
        <div class="htc_graph_legend_item_action_name">
          {{ action.display_name || $t(`browse.${action.group_display_name}`) }}
          <span
            v-html="
              getBetHtml({
                showBetsIn,
                a: action,
                percent_css_class: 'bet-as-pot pot-percent-htc',
                pot_css_class: 'bet-as-pot bet-as-pot-htc',
              })
            "
          ></span>
        </div>
        <div
          class="htc_graph_legend_item_action_value"
          v-html="
            showProp === 'strategy'
              ? numFixedUnit(action.strategy * 100, 'strategy')
              : getEvHtml({
                  ...bettingInfo,
                  ignoreIcmEvIntercept: true,
                  ev: action.ev,
                  simple: true,
                  player: player,
                })
          "
        ></div>
      </div>
      <div class="percent-symbol">
        <span
          class="percent-symbol_text"
          v-html="showProp === 'strategy' ? '%' : getEvUnitHtml({ ...bettingInfo, player: player })"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import CardSymbols from '@/components/CardSymbols/CardSymbols'
import { getEvClr, getEvCompareClr, getEvCompareByPot, getEvTopAction } from '@/helpers/solution'
import {
  getGroupedActions,
  getRaiseGroupedStrategyEvEq,
  getImportantActions,
} from '@/helpers/grouping'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'HandTableCell',
  components: {
    CardSymbols,
  },
  mixins: [format_mix, float_mix],
  props: {
    combo: Object,
    comboPlayer: Object,
    asEmpty: Boolean,
    noValue: Boolean,
    isDimmed: Boolean,
    isLocked: Boolean,
    showFlopContent: Boolean,
    containerSize: Object,
    showBetsIn: String,
    player: String,
    grouping: String,
    hasLegend: { type: Boolean, default: true },
    maximizible: { type: Boolean, default: true },
    maximized: Boolean,
    customGroupingActive: { default: undefined },
    valueKeys: { default: () => ['strategy_eq', 'eq', 'eqr', 'range'] },

    isOutlined: Boolean,

    gameformat: Object,
    hasPremiumGameformat: Boolean,
    showProp: String,
    bettingInfo: Object,
    rangeKey: { default: () => 'range' },
    filterEvCompare: Object,

    viewProps: { default: () => ({}) },
    filterCombos: { default: () => ({ actions: [] }) },
    evProps: { default: () => ({}) },
    hasBlockers: { type: Boolean, default: true },

    useHex: Boolean,
    hasTitle: { type: Boolean, default: true },
    rangeTab: String,
  },
  emits: ['click', 'mouseenter', 'mousedown', 'click:blocker', 'maximize'],
  data() {
    return {}
  },
  methods: {
    handleClick(e) {
      this.maximize()
      this.$emit('click', {
        e,
        combo: this.combo,
        disabled: this.displayEmpty,
      })
    },
    handleMouseenter(e) {
      this.$emit('mouseenter', {
        e,
        combo: this.combo,
        disabled: this.displayEmpty,
      })
    },
    handleMousedown(e) {
      this.$emit('mousedown', {
        e,
        combo: this.combo,
        disabled: this.displayEmpty,
      })
    },
    handleBlockerClick() {
      this.$emit('click:blocker')
      this.$store.dispatch('router_set_dialogs', 'blockers-tips-dialog')
    },
    maximize() {
      if (!this.maximizible) return
      /*
      this.$store.commit('switchers_set', {
        key: 'sw_combos_expand',
        value: this.maximized ? 'swv_shrinked' : 'swv_expanded',
      })
      */
      this.$emit('maximize')
      nextTick(() => {
        const { cell } = this.$refs
        if (cell) {
          setTimeout(() => {
            cell.scrollIntoView(true)
          }, 20)
        }
      })
    },
    getStrategyEvEq(raises) {
      const res = raises.reduce(
        (a, b) => ({
          strategy: a.strategy + b.strategy,
          ev: a.ev + b.strategy * b.ev,
          eq: a.eq + b.strategy * b.eq,
        }),
        {
          strategy: 0,
          ev: 0,
          eq: 0,
        },
      )
      return res
    },
    getBlockerClr(num) {
      // 1 - 10
      if (!this.hasPremiumGameformat) return 'var(--clr-grey-2)'
      const idx = (num - 1) * 10
      const color = `var(--clr-eveqeqrbl${idx})`
      return color
    },
  },
  computed: {
    range() {
      const res = this.comboPlayer?.[this.rangeKey]
      return res
    },
    displayEmpty() {
      // console.log(this.asEmpty,this.combo, this.comboPlayer)
      return this.asEmpty || !this.range
    },
    comboSolution() {
      if (this.showProp === 'ev_compare') {
        return this.combo.solution
      }
      if (this.filterCombos.actions.length) {
        // if (!this.ignoreFilterActions && this.filterCombos.actions.length) {
        const res = this.combo.solution.filter(i =>
          this.filterCombos.actions.some(a => a.code === i.code),
        )
        return res
      }
      return this.combo.solution
    },
    textRowsLength() {
      if (this.rangeTab === 'range') {
        if (this.showProp === 'strategy') {
          return this.groupedComboSolution?.length || 0
        }
        return 4
      }
      if (this.showProp === 'overview_all') {
        return 5
      }
      if (this.showProp === 'ev_compare') {
        return 2
      }
      return this.groupedComboSolution?.length || 0
    },
    groupedComboSolution() {
      let actions = this.comboSolution || []
      if (this.grouping === 'swv_grouping_4') {
        const res = getGroupedActions({
          actions,
          grouping: this.grouping,
          groupValuesFunction: getRaiseGroupedStrategyEvEq,
          raisesFirst: true,
        })
        actions = res
      } else if (this.grouping === 'swv_grouping_all') {
        return this.groupedBets
      } else if (this.maximizible && !this.maximized) {
        if (this.showProp === 'ev_compare' && !this.filterEvCompare.disabled) {
          // will get filtered later
        } else {
          actions = getImportantActions({ actions, max: 6, sortKey: 'strategy' })
        }
      }
      return actions
    },
    comboSolutionLegend() {
      if (this.showProp === 'ev_compare' && !this.filterEvCompare.disabled) {
        if (this.filterEvCompare.compare_by_best_ev_action) {
          const aa_secondary = getEvTopAction({ actions: this.groupedComboSolution })
          return this.groupedComboSolution.filter(
            a =>
              (a.code || a.id) === this.filterEvCompare.action_primary.action_id ||
              (a.code || a.id) === (aa_secondary.code || aa_secondary.id),
          )
        }
        return this.groupedComboSolution.filter(
          a =>
            (a.code || a.id) === this.filterEvCompare.action_primary.action_id ||
            (a.code || a.id) === this.filterEvCompare.action_secondary.action_id,
        )
      }
      return this.groupedComboSolution
    },
    groupedBets() {
      const actions = this.comboSolution || []
      const res = getGroupedActions({
        actions,
        grouping: 'swv_grouping_all',
        groupValuesFunction: getRaiseGroupedStrategyEvEq,
        // groupValues: ['ev', 'eq', 'strategy'],
        raisesFirst: true,
      })
      return res
    },
    groupedBet() {
      const res = this.groupedBets[0]?.action === 'R' ? this.groupedBets[0] : null
      // console.log(res)
      return res
    },
    evCompareClrs() {
      if (this.filterEvCompare.disabled) {
        return this.evClrs
      }

      const { pot, action_primary, action_secondary, compare_by_best_ev_action } =
        this.filterEvCompare

      const aa_primary = this.groupedComboSolution[action_primary.order]
      let aa_secondary = this.groupedComboSolution[action_secondary.order]

      if (compare_by_best_ev_action) {
        aa_secondary = getEvTopAction({ actions: this.groupedComboSolution })
      }
      const ev_difference = aa_primary?.ev - aa_secondary?.ev

      const scaledVal = getEvCompareByPot({ ev_difference, pot })
      const gradient = getEvCompareClr({ eq_compare: scaledVal, clrScale: 10 })
      const color = `var(${gradient})`
      const background = `background:${color}`
      return background
    },
    evClrs() {
      if (this.comboPlayer.evClr) {
        return `background:var(${this.comboPlayer.evClr})` // reports
      }
      const totalEv = this.evProps[`${this.player}_total_ev`]
      const gradient = getEvClr({ total_ev: totalEv, ev: this.comboPlayer?.ev, clrScale: 10 })

      const color = `var(${gradient})`
      const background = `background:${color}`
      return background
    },
    eqClrs() {
      if (this.comboPlayer.eqClr) {
        return `background:var(${this.comboPlayer.eqClr})` // reports
      }
      let background = ''
      const gradient = Math.round((this.comboPlayer?.eq * 100) / 5) * 5
      const color = `var(--clr-eveqeqrbl${gradient})`
      background = `background:${color}`
      return background
    },
    eqrClrs() {
      if (this.comboPlayer.eqrClr) {
        return `background:var(${this.comboPlayer.eqrClr})` // reports
      }
      let background = ''
      const gradient = Math.round((this.comboPlayer?.eqr_clrscaled * 100) / 5) * 5
      const color = `var(--clr-eveqeqrbl${gradient})`
      background = `background:${color}`
      return background
    },
    // TODO refactor + ev eq clrs refactor and unify
    blockers() {
      // TODO: remove 'hero' after 3way release
      if (!this.hasBlockers || !this.hasPremiumGameformat || this.player !== '0') return {}

      const res = {
        ...(this.comboPlayer?.blocker_rate !== -1
          ? { blocker_rate: this.comboPlayer?.blocker_rate?.toFixed() || '' }
          : ''),
        ...(this.comboPlayer?.unblocker_rate !== -1
          ? { unblocker_rate: this.comboPlayer?.unblocker_rate?.toFixed() || '' }
          : ''),
        // blocker_rate: this.comboPlayer?.blocker_rate?.toFixed() || '',
        // unblocker_rate: this.comboPlayer?.unblocker_rate?.toFixed() || '',
      }
      // console.log(this.comboPlayer)
      res.hasSome = res.blocker_rate || res.unblocker_rate
      res.hasAll = res.blocker_rate && res.unblocker_rate
      res.text = `${res.blocker_rate}${res.blocker_rate && res.unblocker_rate ? '/' : ''}${
        res.unblocker_rate
      }`
      return res
    },
    contentStyle() {
      if (this.displayEmpty) return ''

      const height = this.viewProps.study_range_full_height ? '' : `height:${this.range * 100}%`
      if (
        this.showProp === 'strategy' ||
        this.showProp === 'strategy_ev' ||
        this.showProp === 'strategy_eq' ||
        this.showProp === 'overview_all'
      ) {
        return height
      }
      if (this.showProp === 'ev_compare') {
        return `${height};${this.evCompareClrs}`
      }
      if (this.showProp === 'ev') {
        return `${height};${this.evClrs}`
      }
      if (this.showProp === 'eq') {
        return `${height};${this.eqClrs}`
      }
      if (this.showProp === 'eqr') {
        return `${height};${this.eqrClrs}`
      }
      if (this.showProp === 'range') {
        const rangeStyle = this.viewProps.study_range_full_height
          ? `opacity:${this.comboPlayer.range / 1}; background: var(--clr-range)`
          : `${height}; background: var(--clr-range)`
        return rangeStyle
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
.htc-tlltp-blocker-icon {
  font-size: 1.25rem;
  line-height: 0;
  position: relative;
  top: 0.225rem;
  margin-left: -0.225rem;
  &::before {
    display: inline-block !important;
  }
}
.htc_graph_legend_item_unit {
  font-size: clamp(0.6rem, var(--legend-font-size), 0.875rem);
  line-height: 1;
}
// https://css-tricks.com/a-few-times-container-size-queries-would-have-helped-me-out/
.htc_graph_legend {
  container-name: htc_graph_legend;
  container-type: size;
}
@container htc_graph_legend (min-width: 1px) {
  .htc_graph_legend_item {
    --row-height: calc(75cqh / var(--legend-items));
    --max: clamp(1px, 11cqw, var(--htc-fnt-size-max));
    --legend-font-size: clamp(0.5rem, var(--row-height), var(--max));
  }
}
.htc_title_symbols {
  background: var(--clr-white-0);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.25rem;
  height: 100%;
  border-radius: 0 0 4px 0;
}
</style>
<style lang="scss" scoped>
.htc_empty.htc_maximized {
  height: 1.5rem !important;
  min-height: 0 !important;
}

@media (max-width: 1024px) {
  .htc {
    .htc_graph_legend_item {
      pointer-events: none;
    }
  }
}
.htc {
  // overflow: hidden; // dont set overflow hidden, it will break maximized title sticky position
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
  font-size: 1.2rem;
  --htc-fnt-size-max: 2.25rem;

  display: flex;
  flex-shrink: 0;

  --clr-htc-back: var(--clr-combo_range_active);
  --value-size: 2rem;
  background: var(--clr-htc-back);

  --htc-title-height: 1.4rem;
  --htc-title-size: 1rem;
  --htc-blocker-icon-size: 1.25rem;
  --htc-blocker-value-size: 0.875rem;

  // &_icon-lock {
  //   position: absolute;
  //   top: 0;
  //   right: 0;
  //   z-index: 8;
  //   // z-index: 99;
  //   cursor: pointer;
  //   --htc-font-size: 1.5rem;
  //   font-size: calc(var(--htc-font-size) * 0.75);
  //   width: var(--htc-font-size);
  //   height: var(--htc-font-size);
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   background: rgba(0, 0, 0, 0.33);
  //   border-bottom-left-radius: 4px;
  // }

  &_hoverable {
    cursor: inherit;
    &:hover {
      &:before {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 1;
        background: rgba(0, 0, 0, 0.4);
      }
    }
    &.htc_locked {
      &::before {
        background: rgba(255, 0, 0, 0.75) !important;
      }
    }
  }
  &_maximizible {
    z-index: 0;
    pointer-events: unset;
    cursor: n-resize;
    cursor: url('@/assets/cursors/cursor_open.webp'), auto;
  }
  &_maximized {
    cursor: s-resize;
    cursor: url('@/assets/cursors/cursor_close.webp'), auto;
    z-index: 2;
    height: 100%;
    max-height: 100%;
    min-height: 12rem;
    border-bottom: 1px solid black;
    border-radius: 0px !important;
    .htc_title {
      position: sticky;
    }
    .htc_graph_legend {
      pointer-events: all;
      flex-flow: column !important;
      position: absolute;
      height: 100%;
      --left: clamp(28rem, 68%, 100%);
      .percent-symbol {
        font-size: var(--legend-font-size);
        max-width: var(--left);
        &_text {
          position: absolute;
          top: 0.25rem;
          right: 0.5em;
        }
      }
      &_item {
        max-width: var(--left);
        position: relative;
        --htc-fnt-size-max: 3rem;
        &:after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100vw;
          z-index: -1;
        }
        &:hover {
          &:after {
            background: rgba(255, 255, 255, 0.1);
          }
        }
        &:hover {
          // font-weight: 600;
          font-weight: 500;
          position: relative;
        }
      }
    }
  }
  &_empty {
    pointer-events: none;
    --clr-htc-back: var(--clr-combo_range_empty);
    .htc_graph {
      opacity: 0;
    }
    .htc_title {
      text-shadow: none !important;
      opacity: 0.5;
    }
    .htc_value {
      opacity: 0;
    }
  }
  &:after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  &_dimmed {
    &:after {
      z-index: 4;
      background: rgba(0, 0, 0, 0.4);
      transition: 0.2s;
    }
  }
  // &_outlined {
  //   &:after {
  //     z-index: 4;
  //     transition: 0.2s;
  //     border: solid 2px var(--clr-primary);
  //   }
  // }
  &_open {
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 2px;
    right: 2px;
    padding: 0 4px;
    border-radius: 4px;
    font-size: 0.8rem;
  }
  &_title {
    position: absolute;
    z-index: 3;
    flex-shrink: 0;
    top: 0;
    left: 0;
    height: var(--htc-title-height);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    // &_symbols {
    // .htc_title_symbols -- global
    // }
    &_blocker {
      background: var(--clr-white-0);
      border-radius: 0 0 4px 4px;
      height: 100%;
      font-size: var(--htc-title-size);
      font-weight: 500;
      padding: 0 0.175rem 0 0.125rem;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.2s;
      &:hover {
        background: rgb(233, 233, 233);
        cursor: default;
      }
      &_icon {
        position: relative;
        font-size: var(--htc-blocker-icon-size);
      }
      &_value {
        color: var(--clr-black-0);
        padding-right: 1px;
        font-size: var(--htc-blocker-value-size);
      }
    }
    &_lock {
      line-height: 1;
      font-size: var(--htc-title-size);
    }
  }

  --value-padding: 0 0.5rem;
  &_content {
    pointer-events: none;
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 0;
  }
  &_value {
    pointer-events: none;
    position: absolute;
    overflow: hidden;
    z-index: 1;
    bottom: 0;
    left: 0;
    padding: var(--value-padding);
    justify-content: flex-end;
    font-size: var(--value-size);
    font-weight: 300;
    color: var(--clr-black-0);
    display: flex;
    width: 100%;
    text-align: right;
  }
  &_graph_transition {
    .htc_graph_item {
      transition: 0.2s;
    }
  }
  &_graph {
    position: absolute;
    z-index: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    &_legend {
      pointer-events: none;
      overflow: hidden;
      margin-top: auto;
      position: relative;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      padding: 1.75rem 0 0.125em 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      z-index: 1;
      color: var(--clr-combo_text);
      &_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0.25rem;
        font-weight: 300;
        white-space: nowrap;
        position: relative;
        font-size: var(--legend-font-size);
        max-width: 100%;
        line-height: 1;
        &_action_name {
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .percent-symbol {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-right: 0.33rem;
        &_text {
          font-size: 0.875rem;
        }
      }
    }
  }
}
</style>
